import React from 'react'
import Hero from '../components/Hero';
import { useIntl } from 'react-intl';
import NOMLinkBoxRow from '../components/NOMLinkBoxRow';

export type ElectronicsPageProps = {};

const ElectronicsPage: React.FC<ElectronicsPageProps> = () => {
  const intl = useIntl();
  return (
    <div className="w-full">
      <Hero bgImage={'/img/electronics-rs.jpg'} heading={intl.formatMessage({
        id: "electronics",
        defaultMessage: "Electronics"
      })} />
      <NOMLinkBoxRow />
      <div className="content gap-8 items-center text-center">
        <img src="/img/electronics-viz.jpg" alt="" />
      </div>
    </div>
  );
}

export default ElectronicsPage;